
export default function Conclusion() {
  return (
    <section className="py-16 bg-gradient-to-br from-teal-50 to-teal-100">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">まとめ｜今日作るならこの1枚</h2>
        
        <div className="bg-white p-8 rounded-xl shadow-lg mb-8">
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-6">
              即日発行できるクレジットカードは、申し込んだその日からすぐに使えるため、急な出費や今すぐカードが必要な場面で非常に便利です。最短10秒でカード番号が発行され、ネットショッピングやスマホ決済ですぐに利用できます。
            </p>

            <div className="bg-teal-50 border-l-4 border-teal-600 p-6 rounded-lg mb-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <i className="ri-trophy-line text-teal-600"></i>
                総合的に最もおすすめなのは
              </h3>
              <div className="bg-white p-6 rounded-lg">
                <h4 className="text-2xl font-bold text-gray-900 mb-3">三井住友カード（NL）</h4>
                <ul className="space-y-2 mb-4">
                  <li className="flex items-start gap-2 text-gray-700">
                    <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                    <span><strong>最短10秒</strong>でカード番号発行</span>
                  </li>
                  <li className="flex items-start gap-2 text-gray-700">
                    <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                    <span><strong>年会費永年無料</strong>で維持費ゼロ</span>
                  </li>
                  <li className="flex items-start gap-2 text-gray-700">
                    <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                    <span>コンビニ・飲食店で<strong>最大7%還元</strong></span>
                  </li>
                  <li className="flex items-start gap-2 text-gray-700">
                    <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                    <span>タッチ決済対応でスムーズな支払い</span>
                  </li>
                </ul>
                <a
                  href="/mitsui"
                  className="block w-full bg-gradient-to-r from-teal-500 to-teal-600 text-white px-6 py-4 rounded-lg font-bold text-center hover:from-teal-600 hover:to-teal-700 transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-arrow-right-line mr-2"></i>
                  三井住友カード（NL）の詳細を見る
                </a>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">利用シーン別のおすすめ</h3>
            <div className="space-y-4 mb-6">
              <a href="/rakuten" className="block bg-gray-50 p-4 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                <p className="text-gray-700">
                  <strong className="text-teal-600">ECモールをよく使う方：</strong>大手ECモール系カード（基本還元率1.0%、ECモールで最大3倍）
                </p>
              </a>
              <a href="/recruit" className="block bg-gray-50 p-4 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                <p className="text-gray-700">
                  <strong className="text-teal-600">還元率を最重視する方：</strong>リクルートカード（基本還元率1.2%と業界最高水準）
                </p>
              </a>
              <a href="/suruga" className="block bg-gray-50 p-4 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                <p className="text-gray-700">
                  <strong className="text-teal-600">スマホ保険が欲しい方：</strong>地方銀行系スピード発行カード（スマートフォン保険付帯）
                </p>
              </a>
            </div>

            <p className="text-gray-700 leading-relaxed">
              即日発行カードは審査時間が変動することもあるため、時間に余裕を持って申し込むことをおすすめします。本人確認書類や引き落とし口座の準備を事前にしておくと、よりスムーズに手続きが進みます。
            </p>
          </div>
        </div>

        {/* 限定感ブロック */}
        <div className="bg-gradient-to-r from-amber-500 to-orange-500 rounded-2xl p-8 text-white mb-8 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full translate-y-1/2 -translate-x-1/2"></div>
          <div className="relative">
            <div className="flex items-center gap-2 mb-3">
              <i className="ri-gift-line text-2xl"></i>
              <span className="font-bold text-lg">今だけ！新規入会キャンペーン実施中</span>
            </div>
            <p className="text-white/90 mb-4">
              三井住友カード（NL）は新規入会で最大25,600円相当のVポイントプレゼント中！
            </p>
            <div className="flex flex-wrap gap-3 mb-6">
              <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg">
                <div className="text-xs text-white/80">新規入会特典</div>
                <div className="font-bold">最大25,600円相当</div>
              </div>
              <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg">
                <div className="text-xs text-white/80">年会費</div>
                <div className="font-bold">永年無料</div>
              </div>
              <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg">
                <div className="text-xs text-white/80">発行時間</div>
                <div className="font-bold">最短10秒</div>
              </div>
            </div>
            <a
              href="/mitsui"
              className="inline-block bg-white text-amber-600 px-8 py-4 rounded-lg font-bold hover:bg-amber-50 transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-right-line mr-2"></i>
              キャンペーン詳細を見る
            </a>
          </div>
        </div>

        {/* 最終CTA */}
        <div className="text-center space-y-4">
          <a
            href="/ranking"
            className="inline-block bg-white text-teal-600 px-8 py-4 rounded-lg font-bold border-2 border-teal-600 hover:bg-teal-50 transition-all duration-300 whitespace-nowrap cursor-pointer mr-4"
          >
            <i className="ri-list-ordered mr-2"></i>
            総合ランキングを見る
          </a>
          <a
            href="/"
            className="inline-block bg-gray-100 text-gray-700 px-8 py-4 rounded-lg font-bold hover:bg-gray-200 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-line mr-2"></i>
            トップページに戻る
          </a>
        </div>
      </div>
    </section>
  );
}
